import { render, staticRenderFns } from "./APIRequest.vue?vue&type=template&id=f337b8a6&scoped=true&"
import script from "./APIRequest.vue?vue&type=script&lang=js&"
export * from "./APIRequest.vue?vue&type=script&lang=js&"
import style0 from "./APIRequest.vue?vue&type=style&index=0&id=f337b8a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f337b8a6",
  null
  
)

export default component.exports